import { server_connection } from 'config';

export const SEND_PASSWORD_RESET_EMAIL = 'SEND_PASSWORD_RESET_EMAIL';
export const CHECK_TOKEN_VALID = 'CHECK_TOKEN_VALID';
export const CHECK_PASSWORD = 'CHECK_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD_CHANGED = 'RESET_PASSWORD_CHANGED';

export function getUserByEmail(emailAddress) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/get_user_by_email/' + emailAddress)
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData) {
                    dispatch(createPassToken(responseData))
                }
                else {
                    console.log('NO USER FOUND')
                }
            })
    }
}

export function createPassToken(user) {
    const auth_id = user.auth_id;
    const email = user.Email;
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/create_user_pass_token/' + auth_id + '/' + email)
            .then((response) => response.json())
            .then((responseData) => {
                // If it finds a user, it will create the token object and then send the email
                if (responseData.insertId) {
                    dispatch(sendPasswordResetEmail(responseData.insertId));
                }         
            })
    }
}

export function sendPasswordResetEmail(tokenId) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/password-reset-email/' + tokenId)
            .then(
                dispatch({
                    type: SEND_PASSWORD_RESET_EMAIL,
                    payload: true
                })
            )
    }
}

export function resetPassword(newPassword, token) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/reset_password',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    newPassword: newPassword,
                    token: token
                })
            })
    }
}


export function checkTokenValid(token) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/check_token_valid/' + token)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: CHECK_TOKEN_VALID,
                    payload: responseData
                })
            })
    }
}

//For a user logged in that knows current password but wants to change it

export function checkPassword(password, auth_id, newPassword) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/check_password/' + password + '/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData) {
                    dispatch(
                        changePassword(password, newPassword, auth_id)
                    )
                } else {
                    dispatch({
                        type: CHECK_PASSWORD,
                        payload: true
                    })
                }

            })
    }
}

export function changePassword(oldPassword, newPassword, auth_id) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/change_password',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    auth_id: auth_id
                })
            })
            .then(
                dispatch({
                    type: CHANGE_PASSWORD,
                    payload: true
                })
            )
    }
}

export function changePasswordAdmin(newPassword, auth_id, admin_token) {
    return async (dispatch) => {
        await fetch(server_connection + '/auth/change_password_admin',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    newPassword:   newPassword,
                    auth_id:       auth_id,
                    admin_token:   admin_token,
                })
            })
    }
}

export function resetPasswordChanged() {
    return {
        type: RESET_PASSWORD_CHANGED,
        payload: false
    }
}




// WEBPACK FOOTER //
// src/auth/store/actions/passwordreset.actions.js